import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import allActions from '../../state/actions';
import Layout from '../../components/layout/Layout';
import PreloaderBg from '../../components/shared/preloaderBg/PreloaderBg';
import MenuLeft from '../../components/shared/menuLeft/MenuLeft';
import NetsDetail from '../../components/netsDetail/NetsDetail';

const Nets = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const currentPage = useSelector((state) => state.currentPage);
	const user = useSelector((state) => state.user);
	const staticPages = useSelector((state) => state.staticPages);
	const isFetching = currentPage.isFetching;

	useEffect(() => {
		// controllo nello store se ho già il dettaglio di nets, altrimenti eseguo action creator
		const netsPage = staticPages.nets;

		if (netsPage) {
			// setto i metatags
			document.title = netsPage.metaTitle;
			document.getElementsByTagName('META')[2].content = netsPage.metaDesc;
		}

		if (netsPage === undefined || netsPage.detail === undefined) {
			// non ho i dati del prodotto nello store, chiamo action creator fetchNetsDetail
			setTimeout(
				() =>
					dispatch(
						allActions.netsDetailActions.fetchNetsDetail(
							currentPage.currentLang,
							user?.userData?.id
						)
					),
				50
			);
		} else {
			// loading...
			dispatch(allActions.isFetchingAction.loadStoredData());

			// recupero dati da store
			dispatch(allActions.netsDetailActions.loadNetsDetail(netsPage));
		}

		//console.log(netsPage);
	}, [location, staticPages]);

	return (
		<Layout>
			<div className='container mx-auto'>
				<PreloaderBg showPreloader={isFetching} />
				<div className='grid grid-cols-60'>
					<MenuLeft />
					<NetsDetail />
				</div>
			</div>
		</Layout>
	);
};

export default Nets;
